import Lookup from 'src/componentes/select-async';
import FaixaFarolEdit from 'src/paginas/faixa-farol/edit';
import FaixaFarolList from 'src/paginas/faixa-farol/index';

const FaixaFarolLookup = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      showSearch
      searchComponent={FaixaFarolList}
      clearable={true}
      editComponent={FaixaFarolEdit}
      url="/FaixaFarolLookup"
      {...props}
    />
  );
};

export default FaixaFarolLookup;
